import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import { readCookie } from '../../../../../../../src/utils/readCookie';
import { toggleHasDeterminedPersonalizedAds, toggleEUOptInBanner } from '../../../../../redux/actions';
import { userHasOptedIntoPersonalizedAds } from '../../../../../../../shared/lib/google-global-site-tag/index';

const OptInWrapper = styled.div`
  display: ${({ show }) => (show ? 'block' : 'none')};
`;

export default class EUPersonalizedAdsOptIn extends React.Component {
  static propTypes = {
    cookieName: PropTypes.string,
    dispatch: PropTypes.func,
    selectionCallback: PropTypes.func,
    show: PropTypes.bool,
    user: PropTypes.object,
  }

  componentDidMount() {
    const { cookieName, dispatch, user } = this.props;
    // look for the cookie
    const cookieVal = readCookie(cookieName); // is a string here
    if (cookieVal) {
      const value = this.isTrueSet(cookieVal);
      // if it exists, component removes itself
      dispatch(toggleHasDeterminedPersonalizedAds({
        hasDeterminedPersonalizedAds: true,
        value,
      }));
      dispatch(toggleEUOptInBanner(false));
    } else if (user) {
      const optInSelection = userHasOptedIntoPersonalizedAds(user);
      if (optInSelection !== undefined) {
        // can be true or false, undefined means no selection yet
        dispatch(toggleHasDeterminedPersonalizedAds({
          hasDeterminedPersonalizedAds: true,
          value: optInSelection,
        }));
        dispatch(toggleEUOptInBanner(false));
      }
    }
  }

  isTrueSet = val => (val === 'true');

  render() {
    // class names here vs styled because styling should mirror those from external cookie banner
    // styles from rbi-cookie-policy.scss
    return (
      <OptInWrapper
        show={this.props.show}
      >
        <div className='opt-in eu'>
          <div className='pushdown-box'>
            <div className='site-title' />
            <div className='main-information'>
              <h2>
                Do you want personalized ads?
              </h2>
              <p>
                FlightStats uses advertising via Google in order to provide free services to you.
                By clicking yes, the ads displayed will be more relevant to you.
                By clicking no, you will see ads with less relevance.
                If you are subscribed to a premium account, ads are displayed when you are logged out.
              </p>
              <div className='link-wrapper'>
                <a
                  onClick={() => this.props.selectionCallback(true)}
                >
                  YES
                </a>
                <a
                  onClick={() => this.props.selectionCallback(false)}
                >
                  NO
                </a>
              </div>
            </div>
          </div>
        </div>
      </OptInWrapper>
    );
  }
}



// WEBPACK FOOTER //
// ./modules/App/components/children/EUCompliance/children/EUPersonalizedAdsOptIn/EUPersonalizedAdsOptIn.js